import styled from "styled-components";

export const TippingHistoryFooterBox = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  width: 100%;
  text-align: center;
  ${({theme}) => theme.font.presets.body};
`